import { tRouteName } from "./redux/navigation/types";

export const kRoute = Object.freeze({
  P00: "NotFound",
  P01_01: "Application",
  P01_02: "ApplicationSent",
  P01_03: "ForgotPassword",
  P01_04: "ResetPassword",
  P01_05: "CreateUser",
  P01_06: "RevertEmail",
  P01: "Login",
  P02: "Dashboard",
  P03_01: "ViewOrders",
  P03: "AllOrders",
  P03_02: "CreatedOrders",
  P03_03: "AbandonedCarts",
  P03_04: "Payouts",
  P04_01: "Conversation",
  P04: "Messages",
  P05_01: "AddPromotion",
  P05: "Promotions",
  P06: "Connections",
  P06_05: "ViewConnectionsAdmin",
  P06_09: "AdminBrandSettings",
  P06_10: "AdminRetailerSettings",
  P06_11: "AdminRepSettings",
  P07: "CommissionLog",
  P08_01: "AddProduct",
  P08_02: "ShopifyIntegration",
  P08: "Products",
  P09: "Profile",
  P09_01: "ProfilePreview",
  P99: "Brands",
  P100: "BrandLanding",
  P101: "ProductDetails",
  P102: "Checkout",
  P103: "CreateDraft",
  P104: "ShopifyAuthentication",
  P105: "ReferralLinkChecker",
  P10: "ViewRetailer",
  P11: "CurrentStatus", // Admin Only
  P12: "ViewSalesReps", // Brand Only
  P13: "ViewApplications",
  P14: "Customers",
  P15: "ViewSavedBrands",
  P16: "Transactions", // Admin Only
  P16_01: "ViewTransaction", // Admin Only
  P17: "RepMyBrands",
  P18: "RepMyRetailers",
  P19: "ReferralsRewards",
  P20: "ViewSalesRep",
  P21: "RetailerMyBrands",
} as const);

export const kLoginRouteNames: tRouteName[] = [
  kRoute.P01,
  kRoute.P01_01,
  kRoute.P01_02,
  kRoute.P01_03,
  kRoute.P01_04,
  kRoute.P01_05,
  kRoute.P01_06,
  kRoute.P105,
];

export const kOrderRouteNames: tRouteName[] = [kRoute.P03, kRoute.P03_01];

export const kMessageRouteNames: tRouteName[] = [kRoute.P04, kRoute.P04_01];

export const kConnectionRouteNames: tRouteName[] = [
  kRoute.P06,
  kRoute.P06_05,
  kRoute.P06_09,
  kRoute.P06_10,
  kRoute.P06_11,
];

export const kProductRouteNames: tRouteName[] = [kRoute.P08, kRoute.P08_01];

export const kSettingsRouteNames: tRouteName[] = [kRoute.P09];

export const kTransactionRouteNames: tRouteName[] = [kRoute.P16, kRoute.P16_01];

export const kMyRetailersRouteNames: tRouteName[] = [kRoute.P18];

export const kStorefrontRouteNames: tRouteName[] = [
  kRoute.P01,
  kRoute.P99,
  kRoute.P100,
  kRoute.P101,
  kRoute.P102,
  kRoute.P103,
];

export const kRouteNames: readonly string[] = Object.values(kRoute);

export type tRouteParams = {
  [kRoute.P101]: {
    brand: string;
    productId: string;
  };
  [kRoute.P100]: {
    brand: string;
    category?: string;
  };
  [kRoute.P103]: {
    draftId: string;
  };
};
